import type { ModuleNav } from '@saas/ui';

export const invoiceNav: ModuleNav = {
  module: 'invoice',
  items: [{ label: '請求書', to: '/invoices', icon: 'description', newWindow: true, permission: ['invoice.document.read.own', 'invoice.document.read.team', 'invoice.document.read.all'], description: '帳票・入金・売掛残高' }],
  admin: [],
};
